<template>
    <div>
        <div class="w-full vx-col mb-base">
            <vs-card class="p-4 mb-6">
                <div slot="header" class="flex flex-wrap items-center justify-between">
                    <div class="flex items-center">
                        <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                        <h4 style="margin-left: 10px">POD</h4>
                    </div>
                    <div class="flex items-center">
                        <vs-button color="primary" class="mb-4 mr-1 btn md:mb-0" @click="exportTransportNote" icon="print">Print</vs-button>
                        <vs-button color="primary" class="mb-4 mr-1 btn md:mb-0" :disabled="selected.length < 1" @click="confirmPod" icon="check">Confirm</vs-button>
                    </div>
                </div>
                <div class="mt-6 vx-row">
                    <div class="w-full vx-col lg:w-1/4">
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Manifest ID
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-input class="w-full" v-model="data.id" disabled/>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Schedule Date
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-input class="w-full" v-model="data.schedule_date" disabled/>
                            </div>
                        </div>
                    </div>
                    <div class="w-full vx-col lg:w-1/4">
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Origin
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-input class="w-full" v-model="data.origin" disabled/>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Destination
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-input class="w-full" v-model="data.destination" disabled/>
                            </div>
                        </div>
                    </div>
                    <div class="w-full vx-col lg:w-1/4">
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Driver
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-input class="w-full" v-model="data.driver" disabled/>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Vehicle Type
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-input class="w-full" v-model="data.vehicle_type" disabled/>
                            </div>
                        </div>
                    </div>
                    <div class="w-full vx-col lg:w-1/4">
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Police Number
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-input class="w-full" v-model="data.vehicle_code" disabled/>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Transporter
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-input class="w-full" v-model="data.transporter" disabled/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mt-10">
                    <vs-table v-model="selected" :data="data.details" hoverFlat class="mt-5" multiple pagination max-items="20">
                        <template slot="thead">
                            <vs-th style="min-width: 70px; width: 70px">ID</vs-th>
                            <vs-th style="min-width: 200px;">Reference</vs-th>
                            <vs-th style="min-width: 120px;">Req Del Date</vs-th>
                            <vs-th style="min-width: 80px; width: 80px">Qty</vs-th>
                            <vs-th style="min-width: 120px; width: 120px">POD Date</vs-th>
                            <vs-th style="min-width: 80px; width: 120px">POD Status</vs-th>
                            <vs-th style="min-width: 120px; width: 120px">Receiver Name</vs-th>
                            <vs-th style="min-width: 80px; width: 120px">Payment Type</vs-th>
                            <vs-th style="min-width: 80px; width: 120px">Price</vs-th>
                            <vs-th style="min-width: 80px; width: 120px">POD Remark</vs-th>
                            <vs-th style="min-width: 80px; width: 120px">POD Lat Long</vs-th>
                            <vs-th style="min-width: 80px; width: 120px">POD Attachment</vs-th>
                            <vs-th style="min-width: 80px; width: 120px">POD e-Sign</vs-th>
                        </template>
                        <template slot-scope="{data}">
                            <vs-tr :data="detail" :key="index" v-for="(detail, index) in data">
                                <vs-td>
                                    <vs-input class="w-full" v-model="detail.tro_id" :disabled="true"/>
                                </vs-td>
                                <vs-td>
                                    <vs-input class="w-full" v-model="detail.out_ref" :disabled="true"/>
                                </vs-td>
                                <vs-td>
                                    <vs-input class="w-full" v-model="detail.req_del_date" :disabled="true"/>
                                </vs-td>
                                <vs-td>
                                    <vs-input class="w-full" v-model="detail.qty" :disabled="true"/>
                                </vs-td>
                                 <vs-td>
                                    <flat-pickr class="w-full" v-model="detail.pod_time" :config="configdateTimePicker"/>
                                </vs-td>
                                <vs-td>
                                    <vs-select
                                        class="selectExample"
                                        v-model="detail.pod_code_id"
                                        width="100%"
                                        autocomplete
                                    >
                                        <vs-select-item v-for="(item, index) in podCodeOption" :key="index" :value="item.id" :text="item.name"/>
                                    </vs-select>
                                </vs-td>
                                <vs-td>
                                    <vs-input class="w-full" v-model="detail.pod_receiver"/>
                                </vs-td>
                                <vs-td>
                                    <vs-select
                                        class="selectExample"
                                        v-model="detail.pod_payment_type"
                                        width="100%"
                                        autocomplete
                                        @change="changePayment(detail,detail.pod_payment_type)"
                                    >
                                        <vs-select-item v-for="(item, index) in paymentOptions" :key="index" :value="item.id" :text="item.name"/>
                                    </vs-select>
                                </vs-td>

                                <vs-td>
                                    <vs-input class="w-full" :danger="detail.err" val-icon-danger="clear" v-model="detail.pod_price" :disabled="!detail.pod_price_enabled"/>
                                </vs-td>

                                <vs-td>
                                    <vs-input class="w-full" v-model="detail.pod_remark"/>
                                </vs-td>
                                <vs-td>
                                    <vs-input class="w-full" v-model="detail.pod_lat_long"/>
                                </vs-td>
                                <vs-td :data="detail.pod_file">
                                    <vs-button v-if="detail.pod_file" class="mr-1" icon="attachment" size="small" @click="viewAttachment(detail.pod_file)">{{ detail.pod_file }}</vs-button>
                                    <div v-if="!detail.pod_file">
                                    <input

                                        type="file"
                                        id="detail.pod_file"
                                        v-on:change="handleFileUpload($event,detail)"
                                    />
                                    </div>
                                </vs-td>
                                <vs-td :data="detail.pod_sign">
                                    <vs-button v-if="detail.pod_sign" class="mr-1" icon="attachment" size="small" @click="viewAttachment(detail.pod_sign)">{{ detail.pod_sign }}</vs-button>
                                    <div v-if="!detail.pod_sign">
                                    <!-- <input

                                        type="file"
                                        id="detail.pod_sign"
                                        v-on:change="handleFileUpload($event,detail)"
                                    /> -->
                                    </div>
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </div>
            </vs-card>
        </div>
        <vs-popup :title="'Attachment'" :active.sync="showPopupAttachment" id="myAttachpoppup">
            <div class="px-4 pt-4 pb-4 row">
            <div class="pt-5 vx-row">
                <img v-if="attach_name" :src="$http.defaults.baseURL+'/upload/pod/'+attach_name" width="400px"/>
            </div>
                <vs-popup title="Close without Save ?" :active.sync="closePopupAttachment">
                    <p></p>
                </vs-popup>

            </div>
        </vs-popup>
    </div>
</template>

<script>
	import vSelect from 'vue-select'
	import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import moment from "moment";

	export default {
		components:{
			vSelect,
			flatPickr,
		},
		data(){
            return {
                data: {
                    id: '',
                    schedule_date: '',
                    origin: '',
                    destination: '',
                    driver: '',
                    vehicle_type: '',
                    vehicle_code: '',
                    transporter: '',
                    manifest_id: '',
                    total_price: 0,
                    details: [],
                },
                selected: [],
                isLoading: false,
                podCodeOption:[],
                paymentOptions:[
                    {
                        id:3,
                        name:"COD"
                    },
                    {
                        id:4,
                        name:"NON-COD"
                    }
                ],
                attach_name:'',
                configdateTimePicker: {
                    enableTime: true,
                    dateFormat: 'Y-m-d H:i',
                    defaultDate: new Date()
                },
                paymentPrice:false,
                showPopupAttachment:false,
            }
        },
        watch: {
            isLoading: function(){
                if(this.isLoading){
                    this.$vs.loading()
                }
                else{
                    this.$vs.loading.close()
                }
            },
        },
        methods:{
            async confirmPod(){
                let file = new FormData();
                let input_data = {};
                let details = [];
                let totalCOd = 0;
                let codStatus = [];
                let podFailed = [];

                for (const [index, item] of this.selected.entries()) {
                    if(item.pod_payment_type == '3'){
                        const diffPrice = item.pod_faktur - item.pod_price;
                        //console.log('adit'+diffPrice);
                        if(diffPrice > 500) {
                            this.data.details.forEach((el, idx) => {
                                if (el.tro_id === item.tro_id){
                                    // console.log(idx);
                                    this.data.details[idx].err = true;

                                    podFailed.push(item);
                                }
                            });
                        } else {
                            this.data.details.forEach((el, idx) => {
                                if (el.tro_id === item.tro_id){
                                    //console.log(idx);
                                    this.data.details[idx].err = false;

                                    //podFailed.push(item);
                                }
                            });
                        }
                    }

                    if(!item.pod_code_id){
                        this.$vs.notify({
                            color: 'danger',
                            title: 'Error',
                            iconPack: 'feather',
                            icon:'icon-x',
                            text: 'Reference '+item.tro_ref+' POD Code Is Required'
                        })

                        return false;
                    }

                    file.append("pod_file[]",item.pod_file_id);

                    details.push(item);
                    codStatus.push(item.pod_payment_type);
                }

                if(podFailed.length > 0){
                    this.$vs.notify({
                            color: 'danger',
                            title: 'Error',
                            iconPack: 'feather',
                            icon:'icon-x',
                            text: 'Total COD difference more than 500'
                    })

                    return false;
                }


                input_data = { details : details, manifest_id : this.data.manifest_id}

                this.$http.post('transport/pod/update-pod-list', file,{
                headers: {
                    "Content-Type": "multipart/form-data"
                },

                params: input_data
                })
                .then((resp)=>{
                    this.$vs.notify({
                        color: 'success',
                        title: 'Success',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: resp.data.message
                    })
                    this.$router.push({name: 'pod'})
                    this.selected = []
                })
                .catch((error) => {
                for (const [index, error] of error.response.data.message.entries()){
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: error
                    })
                }
                });
            },
            back() {
                if(this.editMode) {
                    this.$vs.dialog({
                        color: 'warning',
                        title: 'Leave Page',
                        text: 'Changes you made may not be saved?',
                        acceptText: 'Leave Page',
                        accept: () => this.$router.push({name: 'pod'}),
                    })
                }
                else{
                    this.$router.push({name: 'pod'})
                }
            },
            fetchAllData() {
                this.data.details = [];
                this.isLoading = true
                Promise.all([
                    this.$http.get('transport/pod/show/' + this.$route.params.id),
                ])
                .then(this.$http.spread((response) => {
                    const pod = response.data;
                    this.data.id = pod.id;
                    this.data.schedule_date = pod.schedule_date;
                    this.data.origin = pod.origin.village;
                    this.data.destination = pod.destination.village;
                    this.data.driver = pod.vehicle.driver;
                    this.data.vehicle_type = pod.vehicle_type.vehicle_type;
                    this.data.vehicle_code = pod.vehicle.vehicle_code;
                    this.data.transporter = pod.transporter.transporter_code;
                    this.data.manifest_id = pod.id;
                    this.data.total_price = pod.total_price;

                    pod.order_list.map(detail => {
                        this.data.details.push({
                            tro_id: detail.tro_id,
                            tro_ref: detail.transport_reference,
                            out_ref: detail.transport_reference,
                            req_del_date: detail.req_del_date,
                            qty: detail.sum_qty,
                            weight: detail.base_gw,
                            volume: detail.base_volume,
                            pod_time: detail.pod_data.pod_time == null ? null : detail.pod_data.pod_time,
                            pod_code_id: detail.pod_data.pod_code_id,
                            pod_code: detail.pod_data.pod_code,
                            pod_description: detail.pod_data.pod_description,
                            pod_remark: detail.pod_data.pod_remark,
                            pod_payment_type: detail.pod_data.pod_payment_type,
                            pod_price: detail.pod_data.pod_payment_price,
                            pod_file: detail.pod_data.pod_file,
                            pod_sign: detail.pod_data.pod_sign,
                            pod_lat_long: detail.pod_data.pod_latitude + ',' + detail.pod_data.pod_longitude,
                            pod_file_id: null,
                            pod_receiver: detail.pod_data.receiver_name,
                            pod_price_enabled: detail.pod_data.pod_payment_type == 3 ? true : false,
                            pod_faktur: detail.faktur_price,
                            err: false,
                        })
                    })
                    this.isLoading = false
                }))
                .catch(() => {
                    this.isLoading = false
                    this.$vs.dialog({
                        type: 'confirm',
                        color: 'danger',
                        title: 'Server Error',
                        text: 'Try again?',
                        accept: () => {
                            this.fetchAllData()
                        },
                        cancel: () => this.$router.push({name: 'pod'}),
                        acceptText: 'Yes',
                        cancelText: 'No'
                    })
                })

                if(this.podCodeOption.length <= 0){
                    this.$http.post("master/podcodes")
                    .then(res => {
                        this.podCodeOption = res.data.data
                        this.isLoading = false;
                    })
                    .catch((error) => {
                        console.log(error)
                    });
                }
            },
            changePayment(detail,payment_id) {
                if(payment_id == 3){
                    detail.pod_price_enabled = true;
                    detail.pod_price = 0;
                }else{
                    detail.pod_price_enabled = false;
                    detail.pod_price = 0;
                }
            },
            handleFileUpload(event,detail){
                detail.pod_file_id = event.target.files[0];
            },
            changePod(detail,pod_id) {
                console.log(pod_id);
            },
            viewAttachment(attch){
                this.isLoading = false ;
                this.showPopupAttachment = true ;
                this.attach_name=attch;
            },
            exportTransportNote() {
                this.isLoading = true
                this.$http.get('transport/routeplanning/report/note/' + this.$route.params.id, { responseType: 'blob'})
                .then(response => {
                    var blob = new Blob([response.data], {
                        type: 'application/pdf'
                    });
                    window.open(URL.createObjectURL(blob));

                    this.isLoading = false
                })
            },
            getDetailIndex(val){
                this.data.details.forEach((el, index) => {
                    if (el.tro_id === val){
                        console.log(index);
                        return index;
                    }
                });
            }
        },
        mounted(){
            this.fetchAllData()
        },
	}
</script>

